import { Outlet } from 'react-router-dom'
import { SiteHeader } from '@/components/SiteHeader'
import { RateTicker } from '@/components/RateTicker'
import { SiteFooter } from '@/components/SiteFooter'
import { useExchangeRates } from '@/hooks/useExchangeRates'
import { RatesProvider } from '@/context/RatesContext'

export function SiteLayout() {
  const ratesState = useExchangeRates()

  return (
    <RatesProvider value={ratesState}>
      <SiteHeader />
      <RateTicker rates={ratesState.fxRates} />
      <main>
        <Outlet />
      </main>
      <SiteFooter />
    </RatesProvider>
  )
}
